export function updateDetailsOnTabChange() {
	if ($("#topPonudaForm").length || $("#topTabFlexOn").length) {
		var getTabIndex = (tabSelector) =>
			$("#topTabFlexOn." + tabSelector)
				.find(".active")
				.closest("li")
				.index() + 1;

		var getTabText = (tabSelector, tabIndex) =>
			$(
				"#topTabFlexOn." + tabSelector + ">li:nth-child(" + tabIndex + ")>a"
			).text();

		var detailsInput = $('#topPonudaForm .wpcf7 input[name="details"]');

		// Cookie helper functions
		function setCookie(name, value, days = 1) {
			const expires = new Date();
			expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
			document.cookie = `${name}=${encodeURIComponent(
				value
			)};expires=${expires.toUTCString()};path=/`;
		}

		function getCookie(name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(";");
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === " ") c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0)
					return decodeURIComponent(c.substring(nameEQ.length, c.length));
			}
			return null;
		}

		function updateDetailsData() {
			var flexOnPackage = getTabText(
				"nav-packages",
				getTabIndex("nav-packages")
			);
			var period = getTabText("nav-period", getTabIndex("nav-period"));
			var distance = getTabText(
				"nav-distance",
				getTabIndex("nav-distance")
			).replace(" godišnje", "");

			var detailsData = `${flexOnPackage}, trajanje: ${period}, kilometraža: ${distance}`;
			detailsInput.val(detailsData);
		}

		if ($("#topPonudaForm").length) {
			updateDetailsData();
		}

		// Update the price when the tab is changed
		function updatePrice() {
			var getTabKey = (tabSelector, tabIndex) =>
				$(
					"#topTabFlexOn." + tabSelector + ">li:nth-child(" + tabIndex + ")>a"
				).attr("data-key");

			var packageKey = getTabKey("nav-packages", getTabIndex("nav-packages"));
			var distanceKey = getTabKey("nav-distance", getTabIndex("nav-distance"));
			var periodKey = getTabKey("nav-period", getTabIndex("nav-period"));

			var prices = $("#flexon_prices").attr("data-prices");
			prices = JSON.parse(prices);
			var price = prices[packageKey][distanceKey][periodKey];
			// Update the price in the HTML
			$(".flexon_price").text(price);
		}

		$('#topTabFlexOn a[data-toggle="tab"]').on("shown.bs.tab", () => {
			if ($("#topPonudaForm").length) {
				updateDetailsData();
			}
			updatePrice();
		});
	}
}
